import React from 'react'
import Gallery from 'react-photo-gallery';

export default class Sample extends React.Component {
    render() {
	return (
	    <Gallery photos={PHOTO_SET} />
	);
    }
}
const PHOTO_SET = [
  {
    src: './images/DSCF3037.JPG',
    width: 3,
    height: 2
  },
  {
    src: './images/DSCF3063.JPG',
    width: 1,
    height: 1
  },
  {
    src: './images/itembackground.png',
    width: 2,
    height: 1
  },
        {
        src: './images/IMG_4492.JPG',
        width: 1,
        height: 2
        },
        
];